import { useSelector } from 'react-redux';
import { Button, Col, Collapse, Input, Row, Form, Select, DatePicker, Divider } from 'antd';
import { dateFormat } from '../../utils/constants';
import { handleDateConvertForApis } from '../../utils/functions';

const Filters = ({ onFilterData, onResetData, filterValues, filtersInitValues, totalDocNr, pageNumber, pageSize, }) => {

    const [form] = Form.useForm();
    const { RangePicker } = DatePicker;
    const totalPages = Math.ceil(totalDocNr / pageSize);
    const regionsList = useSelector(state => state.regions.regions);
    const documentTypesDistinteList = useSelector(state => state.docTypes.docTypesDistinte);
    const suppliersList = useSelector(state => state.suppliers.suppliers);

    const onClearFilter = () => {
        form.setFieldsValue(filtersInitValues);
        onResetData();
    }

    const onFilter = (values) => {
        if (values.dateAddedRange && values.dateAddedRange.length > 0) {
            let dateAddedPicker = values.dateAddedRange;
            values["dateAddedFrom"] = handleDateConvertForApis(dateAddedPicker[0].$d);
            values["dateAddedTo"] = handleDateConvertForApis(dateAddedPicker[1].$d);
        }

        if (values.dateUpdatedRange && values.dateUpdatedRange.length > 0) {
            let lastUpdatedDatePicker = values.dateUpdatedRange;
            values["lastUpdatedDateFrom"] = handleDateConvertForApis(lastUpdatedDatePicker[0].$d);
            values["lastUpdatedDateTo"] = handleDateConvertForApis(lastUpdatedDatePicker[1].$d);
        }

        if (values.monthRange && values.monthRange.length > 0) {
            let monthRangePicker = values.monthRange;
            values["monthFrom"] = handleDateConvertForApis(monthRangePicker[0].$d);
            values["monthTo"] = handleDateConvertForApis(monthRangePicker[1].$d);
        }

        onFilterData(values);
    };

    const FilterContent = () => {
        return (
            <div className='documentFilters'>
                <Row gutter={[16, 16]} className='rowmb0'>
                    <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Form
                            form={form}
                            name="filters"
                            layout="vertical"
                            onFinish={onFilter}
                            autoComplete="off"
                        >

                            <Row gutter={{ lg: 24 }} className='rowmb0'>

                                <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 6 }} md={{ span: 4 }} lg={{ span: 4 }}>
                                    <Form.Item
                                        label="Mese"
                                        name="monthRange"
                                        initialValue={filterValues.monthRange}
                                    >
                                        <RangePicker
                                            picker="month"
                                            style={{ width: "100%" }}
                                            format={'MM/YYYY'}
                                            placeholder={["Mese inizio", 'Mese fine']}
                                            onChange={() => form.submit()}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 6 }} md={{ span: 4 }} lg={{ span: 4 }}>
                                    <Form.Item
                                        label="Manutentore"
                                        name="supplierID"
                                        initialValue={filterValues.supplierID}
                                    >
                                        <Select
                                            showSearch
                                            optionFilterProp="label"
                                            placeholder="Manutentore"
                                            allowClear={true}
                                            options={suppliersList}
                                            onChange={() => form.submit()}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 6 }} md={{ span: 4 }} lg={{ span: 4 }}>
                                    <Form.Item
                                        label="CNA Provinciale"
                                        name="regionId"
                                        initialValue={filterValues.regionId}
                                    >
                                        <Select
                                            showSearch
                                            optionFilterProp="label"
                                            placeholder="CNA Provinciale"
                                            allowClear
                                            options={regionsList}
                                            onChange={() => form.submit()}
                                        />

                                    </Form.Item>
                                </Col>

                                <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 6 }} md={{ span: 4 }} lg={{ span: 4 }}>
                                    <Form.Item
                                        label="Tipo"
                                        name="documentTypeDistinte"
                                        initialValue={filterValues.documentTypeDistinte}
                                    >
                                        <Select
                                            showSearch
                                            optionFilterProp="label"
                                            placeholder="Tipo"
                                            allowClear={true}
                                            options={documentTypesDistinteList}
                                            onChange={() => form.submit()}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 6 }} md={{ span: 4 }} lg={{ span: 4 }}>
                                    <Form.Item
                                        label="Batch"
                                        name="flux"
                                        initialValue={filterValues.flux}
                                    >
                                        <Input placeholder='Batch' onClear={() => form.submit()} allowClear />
                                    </Form.Item>
                                </Col>

                                <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 6 }} md={{ span: 4 }} lg={{ span: 4 }}>
                                    <Form.Item
                                        label="Data caricamento"
                                        name="dateAddedRange"
                                        initialValue={filterValues.dateAddedRange}
                                    >
                                        <RangePicker
                                            style={{ width: "100%" }}
                                            format={dateFormat}
                                            placeholder={["Data d'inizio", 'Data di fine']}
                                            onChange={() => form.submit()}
                                            allowClear={true} />
                                    </Form.Item>
                                </Col>

                                <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 6 }} md={{ span: 4 }} lg={{ span: 4 }}>
                                    <Form.Item
                                        label="Data modifica"
                                        name="dateUpdatedRange"
                                        initialValue={filterValues.dateUpdatedRange}
                                    >
                                        <RangePicker
                                            style={{ width: "100%" }}
                                            format={dateFormat}
                                            placeholder={["Data d'inizio", 'Data di fine']}
                                            onChange={() => form.submit()}
                                            allowClear={true} />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Divider />

                            <Row gutter={{ lg: 24 }}>
                                <Col className="gutter-row filterButtons" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                    <Form.Item style={{ marginBottom: 0 }}>
                                        <Button className='mr10' type="primary" htmlType="submit">Filtra</Button>
                                    </Form.Item>
                                    <Form.Item style={{ marginBottom: 0 }}>
                                        <Button onClick={() => onClearFilter()}>Rimuovi</Button>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </div>
        )
    }

    return (
        <>
            <Collapse
                size='small'
                defaultActiveKey={['1']}
                items={[
                    {
                        key: '1',
                        label: `Filtra documenti - Visualizzando ${totalDocNr} documenti (Pagina: ${pageNumber}/${totalPages})`,
                        children: <FilterContent />
                    },
                ]}
            />
        </>
    );
}

export default Filters;